import { Disclosure } from "@headlessui/react";
import { Cross1Icon, MixerHorizontalIcon } from "@radix-ui/react-icons";
import { Ensure, MessageTableFilters } from "lib/types";
import AddressInputFilter from "./AddressInputFilter";
import ChainSelectFilter, { ChainOptions } from "./ChainSelectFilter";
import DateRangeFilter from "./DateRangeFilter";

export default function Filters({
  chainOptions,
  filters,
  setFilters,
  reset,
}: {
  chainOptions: ChainOptions;
  filters: Ensure<
    MessageTableFilters,
    "chain" | "origin" | "source" | "target"
  >;
  setFilters: (val: Partial<MessageTableFilters>) => void;
  reset: () => void;
}) {
  return (
    <Disclosure>
      <div className="mb-4 flex max-w-full flex-col items-start space-y-2 text-lg text-white lg:flex-row lg:items-center lg:space-y-0 lg:space-x-4">
        <Disclosure.Button
          as="button"
          className="inline-flex items-center rounded-md border border-transparent bg-gray-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm ring-offset-succinct-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          <MixerHorizontalIcon
            className="-ml-0.5 mr-2 h-4 w-4"
            aria-hidden="true"
          />
          Filters
        </Disclosure.Button>
        <Disclosure.Panel className="flex flex-col items-start space-y-4 lg:flex-row lg:items-center lg:space-y-0 lg:space-x-4">
          <ChainSelectFilter
            name="Target"
            options={chainOptions}
            value={filters.chain}
            setValue={(val) => setFilters({ chain: val })}
            // remount if value is reset so the input resets too, but input value stays otherwise
            key={"TargetChain_" + filters.chain.join(",")}
          />
          <AddressInputFilter
            name="Origin"
            value={filters.origin}
            setValue={(val) => setFilters({ origin: val })}
            key={"OriginAddress_" + filters.origin}
          />
          <AddressInputFilter
            name="Source"
            value={filters.source}
            setValue={(val) => setFilters({ source: val })}
            key={"SourceAddress_" + filters.source}
          />
          <AddressInputFilter
            name="Target"
            value={filters.target}
            setValue={(val) => setFilters({ target: val })}
            key={"TargetAddress_" + filters.target}
          />
          <DateRangeFilter
            name="Date"
            value={[filters.startDate, filters.endDate]}
            setValue={([start, end]) =>
              setFilters({ startDate: start, endDate: end })
            }
            key={"Date_" + filters.startDate?.toString()}
          />
          {/* <button
            onClick={reset}
            className="inline-flex items-center rounded border border-transparent bg-red-100 px-2.5 py-1.5 text-xs font-medium text-red-700 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            <Cross1Icon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />{" "}
            Reset
          </button> */}
        </Disclosure.Panel>
      </div>
    </Disclosure>
  );
}
